import React, { useEffect, useState } from 'react';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { listClasses } from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';

import ProductCard from '../components/ProductCard';
import { useDispatch, useSelector } from 'react-redux';
import { getSpecificProducts } from '../../../redux/userHandle';

const CustomerOrders = () => {
    const dispatch = useDispatch();
    const { loading, responseSpecificProducts } = useSelector(state => state.user);

    useEffect(() => {
        dispatch(getSpecificProducts("getOrderedProductsByCustomer"));
    }, [dispatch]);

    const sortOptions = [
        { value: 'oldest', label: 'Oldest' },
        { value: 'newest', label: 'Newest' }
    ];

    const [open, setOpen] = useState(null);
    const [selectedOption, setSelectedOption] = useState('newest');

    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClose = () => {
        setOpen(null);
    };

    const handleMenuItemClick = (value) => {
        setSelectedOption(value);
        handleClose();
    };

    const specificProductData = responseSpecificProducts ? responseSpecificProducts.data : []; // Assuming responseSpecificProducts has a data property

    return (
        <>
            {loading ? (
                <Typography variant="h4" align="center">
                    Loading...
                </Typography>
            ) : (
                <Container>
                    <Typography variant="h4" align="center" sx={{ mb: 3 }}>
                        My Orders
                    </Typography>
                    {specificProductData.length === 0 ? (
                        <Typography variant="h6" align="center">
                            No Orders Till Now
                        </Typography>
                    ) : (
                        <>
                            <Stack
                                direction="row"
                                alignItems="center"
                                flexWrap="wrap-reverse"
                                justifyContent="flex-end"
                                sx={{ mb: 5 }}
                            >
                                <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
                                    <Button
                                        disableRipple
                                        color="inherit"
                                        onClick={handleOpen}
                                        endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                    >
                                        Sort By:&nbsp;
                                        <Typography component="span" variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                            {sortOptions.find(option => option.value === selectedOption)?.label}
                                        </Typography>
                                    </Button>

                                    <Menu
                                        open={Boolean(open)}
                                        anchorEl={open}
                                        onClose={handleClose}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        sx={{
                                            [`& .${listClasses.root}`]: {
                                                p: 0,
                                            },
                                        }}
                                    >
                                        {sortOptions.map((option) => (
                                            <MenuItem
                                                key={option.value}
                                                selected={option.value === selectedOption}
                                                onClick={() => handleMenuItemClick(option.value)}
                                            >
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Stack>
                            </Stack>

                            <Grid container spacing={3}>
                                {specificProductData.map((product, index) => (
                                    <Grid item key={index} xs={12} sm={6} md={3}>
                                        <ProductCard product={product} />
                                    </Grid>
                                ))}
                            </Grid>
                        </>
                    )}
                </Container>
            )}
        </>
    );
};

export default CustomerOrders;
